import { render } from "./ComboBoxes.vue?vue&type=template&id=4faf60b1"
import script from "./ComboBoxes.vue?vue&type=script&lang=js"
export * from "./ComboBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__